import React, { useEffect, useState } from 'react'
import { Timeline, Row, Col, Icon, Modal, Descriptions, Collapse, Table, Tag, Tabs } from 'antd'
import { queryRootAgency, queryAgencyByPid } from '@/services/basicinfo'
import moment from 'moment'
import styles from './index.less'
import { CUSTOM_INFO, MARITAL_STATUS_ENUM, EDUCATION_ENUM, GENDER_ENUM } from '@/utils/consts'
const { TabPane } = Tabs;
const { Panel } = Collapse;

const PeopleModel = ({ info, onOk, ...modalProps }) => {
  const [questionTags, setQuestionTags] = useState([])
  const [maritalStatusStr, setMaritalStatusStr] = useState('')
  const [educationStr, setEducationStr] = useState('')
  const [genderStr, setGenderStr] = useState('')

  useEffect(() => {
    let questionTags = []
    if (info && info.questionType) {
      questionTags = questionTags.concat(info.questionType.split(','))
    }
    if (info && info.otherQuestion) {
      questionTags.push(info.otherQuestion)
    }
    const maritalStatusStr = info && info.maritalStatus && MARITAL_STATUS_ENUM.some(_ => _.value === info.maritalStatus) ? MARITAL_STATUS_ENUM.filter(_ => _.value === info.maritalStatus)[0].label : ''
    const educationStr = info && info.education && EDUCATION_ENUM.some(_ => _.value === info.education) ? EDUCATION_ENUM.filter(_ => _.value === info.education)[0].label : ''
    const genderStr = info && info.gender && GENDER_ENUM.some(_ => _.value === info.gender) ? GENDER_ENUM.filter(_ => _.value === info.gender)[0].label : ''
    setQuestionTags([...questionTags])
    setMaritalStatusStr(maritalStatusStr)
    setEducationStr(educationStr)
    setGenderStr(genderStr)
  }, [])

  const familyColumns = [
    {
      dataIndex: 'name',
      title: '姓名',
      width: 80,
    },
    {
      dataIndex: 'relation',
      title: '关系',
      width: 60,
    },
    {
      dataIndex: 'age',
      title: '年龄',
      width: 60,
    },
    {
      dataIndex: 'occupation',
      title: '职业',
      width: 140,
    },
    {
      dataIndex: 'telephone',
      title: '电话',
      width: 120,
    },
    {
      dataIndex: 'emergency',
      title: '紧急联系人',
      width: 100,
      align: 'center',
      render(text) {
        return text ? '是' : '否'
      }
    }
  ]


  return (
    <Modal {...modalProps}>
        <Collapse bordered={false} defaultActiveKey={['1', '2', '3']} expandIconPosition="right">
          <Panel header="基本信息" key="1">
            {info && <Descriptions>
              <Descriptions.Item label="姓名">{info.name}</Descriptions.Item>
              <Descriptions.Item label="性别">{genderStr}</Descriptions.Item>
              <Descriptions.Item label="电话">{info.phone}</Descriptions.Item>
              <Descriptions.Item label="微信">{info.weixinId}</Descriptions.Item>
              <Descriptions.Item label="身高">{info.height} cm</Descriptions.Item>
              <Descriptions.Item label="体重">{info.weight} kg</Descriptions.Item>
              <Descriptions.Item label="婚姻状况">{maritalStatusStr}</Descriptions.Item>
              <Descriptions.Item label="年龄">{info.age}</Descriptions.Item>
              <Descriptions.Item label="生日">{info.birthday}</Descriptions.Item>
              <Descriptions.Item label="学历">{educationStr}</Descriptions.Item>
              <Descriptions.Item label="居住城市">{info.address}</Descriptions.Item>
              <Descriptions.Item label="职业">{info.occupation}</Descriptions.Item>
              <Descriptions.Item label="客户级别">{info.classification}</Descriptions.Item>
              <Descriptions.Item label="一级渠道">{info.firstChannelName}</Descriptions.Item>
              <Descriptions.Item label="二级渠道">{info.secondChannelName}</Descriptions.Item>
              <Descriptions.Item label="预约习惯">{info.appointmentHabit}</Descriptions.Item>
              <Descriptions.Item label="心理顾问">{info.consultantDoctorName}</Descriptions.Item>
              <Descriptions.Item label="私人管家">{info.personalDoctorName}</Descriptions.Item>
              <Descriptions.Item span={2} label="备注">{info.comment}</Descriptions.Item>
            </Descriptions>}
          </Panel>
          {info && <Panel header="家庭信息" key="2">
            {info.customerFamilies && info.customerFamilies.length &&
              <Table
                size="small"
                bordered={false}
                columns={familyColumns}
                dataSource={info.customerFamilies}
                pagination={false}
              />
            }
          </Panel>}
          {info && <Panel header="需求描述" key="3">
            <div className={styles.questions}>
              {
                questionTags.map(_ => <Tag color="#1890FF" key={_}>{_}</Tag>)
              }
            </div>
            <Descriptions>
              <Descriptions.Item label="核心诉求描述">{info.coreRequirement}</Descriptions.Item>
            </Descriptions>
          </Panel>}
        </Collapse>
      </Modal>
  )
}
export default PeopleModel
